// export const host = "https://www.nextolive.in:2705";
export const host = "https://smartqchat.nextolive.in";